import React from "react";
import { useNavigate } from "react-router-dom";
import "./breadCrumb.css";
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';

const BreadCrumb = ({ breadcrumbs, paths }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = (path, onClick) => {
    if (onClick) {
      navigate(location.pathname, { state: null, replace: true });
      onClick();
    } else {
      navigate(path);
    }
  };

  const renderBreadcrumbs = () => {
    return breadcrumbs.map((breadcrumb, index) => {
      const pathObject = typeof paths[index] === "string" ? { path: paths[index] } : paths[index];

      return (
        <li key={index} className="breadCrumb-item">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleClick(pathObject.path, pathObject.onClick);
            }}
            className={index === breadcrumbs.length - 1 ? "last-item" : "normal-item"}>
            {t(breadcrumb) || ""}
          </a>
          {index < breadcrumbs.length - 1 && <span className="separator">/</span>}
        </li>
      );
    });
  };

  return (
    <div className="model-overlay">
      <div className="model-content">
        <ul className="breadCrumb">{renderBreadcrumbs()}</ul>
      </div>
    </div>
  );
};

export default BreadCrumb;
